import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import {
  BoxModelIcon,
  CardStackIcon,
  Crosshair1Icon,
  FilePlusIcon,
  MixIcon,
  ReaderIcon,
  RocketIcon,
} from "@radix-ui/react-icons";
import { ReactComponent as elgiganten } from "branchAndBrandSpecific/utils/brandVariables/assets/siteRoutes/elgiganten_logo.svg";
import { ReactComponent as logitech } from "branchAndBrandSpecific/utils/brandVariables/assets/siteRoutes/logitech-g_logo.svg";

// Route Props
interface RouteProps {
  title: string;
  link: string;
  logo: any;
}

export const Logitech_siteRoutes = ({ authRole }: { authRole: boolean }) => {
  const routes: { [key: string]: RouteProps[] } = {
    "routes.headlines.main": [
      brand.hasFeature.posts && {
        title: "routes.route.feed",
        link: siteRoutes["dashboard"],
        logo: CardStackIcon,
      },
      brand.hasFeature.zones && {
        title: "routes.route.zones",
        link: siteRoutes["zones"],
        logo: BoxModelIcon,
      },
      brand.hasFeature.news && {
        title: "routes.route.news",
        link: siteRoutes["news"],
        logo: ReaderIcon,
      },
    ].filter(Boolean) as RouteProps[],
    "routes.headlines.engagement": [
      brand.hasFeature.challenges && {
        title: "routes.route.overview",
        link: siteRoutes["challenges"],
        logo: MixIcon,
      },
      brand.hasFeature.challenges && {
        title: "Logitech G Challenge",
        link: siteRoutes["forzamotorsport"],
        logo: logitech,
      },
    ].filter(Boolean) as RouteProps[],
    Shop: [
      brand.hasFeature.challenges && {
        title: "Buy in Elgiganten",
        link: "https://www.elgiganten.se/brand/logitech-g/logitech-g-simulation?q=Logitech+G+-+Simulation&queryType=category",
        logo: elgiganten,
      },
    ].filter(Boolean) as RouteProps[],
    "routes.headlines.admin": [
      brand.hasCreate.challenges &&
        authRole && {
          title: "routes.route.create.challenge",
          link: siteRoutes["createChallenge"],
          logo: MixIcon,
        },
      brand.hasCreate.news &&
        authRole && {
          title: "routes.route.create.news",
          link: siteRoutes["createNews"],
          logo: FilePlusIcon,
        },
    ].filter(Boolean) as RouteProps[],
  };

  return routes;
};
